<template>
	<div>
		<title>订单中心-以诺教育</title>
          <h1 class="orderCenter">订单中心</h1>
          <div class="whole">
            <p class="wholeOrder">全部订单</p>
          </div>
        <div class="orderShow" v-for="v in zhResult.filter(v=>v.order_status==1)">
          <div class="showTime">
            <p class="ding">订单编号：<span>{{v.order_id}}</span></p>
            <p class="dan">下单时间：{{v.order_date}}</p>
          </div>
          <div class="clears"></div>
          <div class="payList">
            <ul class="listInfo">
              <li class="info1"><img :src="v.img_url"/></li>
              <li class="info2">
                <h1>{{v.name}}</h1>
                <p><span></span>{{v.address}}</p>
              </li>
              <li class="info3">￥{{v.price<0?0.00:v.price}}</li>
              <li class="info4">待支付</li>
              <li class="info5">
                <p class="Surplus" v-if="v.pending_paytime>=86400">剩余{{Math.floor(v.pending_paytime/(60 * 60 *24))}}天支付</p>
                <p class="Surplus" v-if="v.pending_paytime<86400">剩余{{Math.floor(v.pending_paytime/(60 * 60))}}:{{Math.floor((v.pending_paytime%(60 * 60))/60)}}:{{Math.floor(Math.floor((v.pending_paytime%(60 * 60))%60))}}支付</p>
                <div class="immediatePay"><router-link :to="{name:'PaymentOrder',params:{id:v.order_id}}" class="PaymentOrder">立即支付</router-link></div>
                <p class="zhCancel" @click="cancel(v)">取消订单</p>
                <p><router-link :to="{name:'orderDetail',params:{id:v.order_id}}" class="orderDetail">查看订单</router-link></p>
              </li>
             </ul>
          </div>
     </div>

		  <div class="orderShow OS"  v-for="v in zhResult.filter(v=>v.order_status==0)">

          <div class="showTime ST">
          <p class="ding">订单编号：<span>{{v.order_id}}</span></p>
          <p class="dan">下单时间：{{v.order_date}}</p>
          </div>
          <div class="clears"></div>
          <div class="payList">
          <ul class="listInfo">
          <li class="info1"><img :src="v.img_url"/></li>
          <li class="info2">
            <h1>{{v.name}}</h1>
            <p><span></span>{{v.address}}</p>
          </li>
          <li class="info3">￥{{v.price}}</li>
          <li class="info4 examine">待审核</li>
          <li class="info5 leftB">
            <p><router-link :to="{name:'orderDetail',params:{id:v.order_id}}" class="orderDetail">查看订单</router-link></p>
          </li>
        </ul>
        </div>
        </div>
      <div class="orderShow OS" v-for="v in zhResult.filter(v=>v.order_status==2)">
          <div class="showTime ST">
            <p class="ding">订单编号：<span>{{v.order_id}}</span></p>
            <p class="dan">下单时间：{{v.order_date}}</p>
          </div>
          <div class="clears"></div>
          <div class="payList">
            <ul class="listInfo">
              <li class="info1"><img :src="v.img_url"/></li>
              <li class="info2">
                <h1>{{v.name}}</h1>
                <p><span></span>{{v.address}}</p>
              </li>
              <li class="info3">￥{{v.price}}</li>
              <li class="info4 examine">已付款</li>
              <li class="info5 leftB">
                <p><router-link :to="{name:'orderDetail',params:{id:v.order_id}}" class="orderDetail">查看订单</router-link></p>
              </li>
            </ul>
          </div>
        </div>

          <div class="orderShow OS"  v-for="v in zhResult.filter(v=>v.order_status==3)">

            <div class="showTime ST">
              <p class="ding">订单编号：<span>{{v.order_id}}</span></p>
              <p class="dan">下单时间：{{v.order_date}}</p>
            </div>
            <div class="clears"></div>
            <div class="payList">
              <ul class="listInfo">
                <li class="info1"><img :src="v.img_url"/></li>
                <li class="info2">
                  <h1>{{v.name}}</h1>
                  <p><span></span>{{v.address}}</p>
                </li>
                <li class="info3">￥{{v.price}}</li>
                <li class="info4 examine">已取消</li>
                <li class="info5 leftB">
                  <p><router-link :to="{name:'orderDetail',params:{id:v.order_id}}" class="orderDetail">查看订单</router-link></p>
                  <p class="zhCancel" @click="cancel1(v)">删除订单</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="orderShow OS"  v-for="v in zhResult.filter(v=>v.order_status==4)">

            <div class="showTime ST">
              <p class="ding">订单编号：<span>{{v.order_id}}</span></p>
              <p class="dan">下单时间：{{v.order_date}}</p>
            </div>
            <div class="clears"></div>
            <div class="payList">
              <ul class="listInfo">
                <li class="info1"><img :src="v.img_url"/></li>
                <li class="info2">
                  <h1>{{v.name}}</h1>
                  <p><span></span>{{v.address}}</p>
                </li>
                <li class="info3">￥{{v.price}}</li>
                <li class="info4 examine">已关闭</li>
                <li class="info5 leftB">
                  <p><router-link :to="{name:'orderDetail',params:{id:v.order_id}}" class="orderDetail">查看订单</router-link></p>
                  <p class="zhCancel" @click="cancel1(v)">删除订单</p>
                </li>
              </ul>
            </div>
          </div>
        <div class="orderShow OS"  v-for="v in zhResult.filter(v=>v.order_status==5)">

          <div class="showTime ST">
            <p class="ding">订单编号：<span>{{v.order_id}}</span></p>
            <p class="dan">下单时间：{{v.order_date}}</p>
          </div>
          <div class="clears"></div>
          <div class="payList">
            <ul class="listInfo">
              <li class="info1"><img :src="v.img_url"/></li>
              <li class="info2">
                <h1>{{v.name}}</h1>
                <p><span></span>{{v.address}}</p>
              </li>
              <li class="info3">￥{{v.price}}</li>
              <li class="info4 examine">已退款</li>
              <li class="info5 leftB">
                <p><router-link :to="{name:'orderDetail',params:{id:v.order_id}}" class="orderDetail">查看订单</router-link></p>
              </li>
            </ul>
          </div>
        </div>
			<div class="zhhContent">
              <Page :total="zhPage1.total" :page-size="10" @on-change="handlePage1"></Page>
            </div>
            <div class="zhTotal">
              共{{zhPage1.total}}条记录
            </div>
            <!--弹框-->
          <div class="zhTan" v-show="tishi">
      <div class="zhBlock">
          <div class="zhBlockTop">提示<Icon type="close" class="zhIcon"></Icon></div>
         <div class="zhTishi">你确定要取消订单吗？</div>
        <div class="zhQue">
          <button class="zhDetermine" @click="queding" :disabled="allow"><router-link to="/orderList" style="color:#ffffff">确定</router-link></button>
          <div class="zhDetermine1">取消</div>
       		 </div>
      	   </div>
    	</div>
    	  <div class="zhTan" v-show="tishi1">
      <div class="zhBlock">
          <div class="zhBlockTop">提示<Icon type="close" class="zhIcon"></Icon></div>
         <div class="zhTishi">你确定要删除订单吗？</div>
        <div class="zhQue">
          <button class="zhDetermine" @click="queding1" :disabled="allow"><router-link to="/orderList" style="color:#ffffff">确定</router-link></button>
          <div class="zhDetermine1">取消</div>
       		 </div>
      	   </div>
      	   <div class="clear"></div>
    	</div>
		</div>
</template>

<script>
	export default{
		name:"Myorder",
		data(){
			return{
				zhResult:[],
				zhPage1:{},
				tishi:false,
	       		tishi1:false,
	       		xiabiao:'',
	       		allow:false,
			}
		},
		methods:{
			cancel(v){
				this.tishi=true
				this.xiabiao=v.order_id
			},
			cancel1(v){
				this.tishi1=true
				this.xiabiao=v.order_id
			},
			queding(){
				this.allow=true
				this.$ajax({
					method:"post",
					url:'/api/CancelOrder',
					params:{order_id:this.xiabiao}
				}).then(function(data){
					if(data.data.result.status=='ok'){
						 history.go(0)
					}
				}).catch(function(err){
					console.log(err)
				})
			},
			queding1(){
				this.allow=true
				this.$ajax({
					method:"post",
					url:'/api/DeleteOrder',
					params:{order_id:this.xiabiao}
				}).then(function(data){
					if(data.data.result.status=='ok'){
						 history.go(0)
					}
				}).catch(function(err){
					console.log(err)
				})
			},
			handlePage1(i){
      	var that=this;
      	that.$ajax({
      		method:"post",
      		url:"/api/MyOrder",
      		params:{page:i}
      	}).then(function(data){
      		that.zhResult = data.data.result;
      		that.zhPage1=data.data.meta.pagination;
      	}).catch(function(err){
      		console.log(err)
      	})
      },
		},
		mounted(){
			var that=this
			//初始数据 订单中心
		  that.$ajax({
		    method:"post",
		    url:"/api/MyOrder",
		  })
		  .then(function(data){
		    that.zhResult = data.data.result;
		    that.zhPage1=data.data.meta.pagination;
          if(that.zhResult < 2){
            $(".orderRight").eq(0).css({"height":"353px"})
          }
		  })
		  /*------------------------------点击取消提示------------------------------------*/
      $(".zhDetermine1").click(function(){
         that.tishi=false
         that.tishi1=false
      })
		  $(".zhIcon").click(function(){
		  	that.tishi=false
		  	that.tishi1=false
		  })
		}
	}
</script>

<style>
	.orderList .orderRight{float:right;width:920px;background:#fff;border-left:10px solid #f4f5f9;min-height: 700px;}
  .orderList .portrait{width:95px;height:95px;border-radius: 50%;margin:50px auto 18px;overflow:hidden;}
  .orderList .portname{width:100%;height:70px;border-bottom:1px solid #e6e6e6;text-align: center;}
  .orderList .orderLast{width:100%;margin-top:20px;}
  .orderList .orderC{width:100%;line-height:50px;text-align: center;font-size: 16px;cursor:pointer;}
  .orderList .activeD{background:#11cc99;color:#fff;}
  .orderList .orderCenter{font-size: 20px;font-weight: 100;margin:26px 30px;}
  .orderList .whole{width:850px;height:50px;border-bottom:2px solid #e6e8f0;margin-left:30px;}
  .orderList .wholeOrder{width:90px;line-height:48px;text-align: center;border-bottom:2px solid #01b784;color:#01b784;}
  .orderList .orderShow{margin:30px;border:1px solid #b7e7d7;height:180px;width:850px;box-sizing:border-box;}
  .orderList .orderShow:hover{box-shadow:0 0 10px rgba(0,0,0,.1)}
  .orderList .OS{border:1px solid #e6e6e6;}
  .orderList .showTime{width:100%;height:48px;border-bottom:1px solid #b7e7d7;background:#eaf7f4;box-sizing:border-box;}
  .orderList .ST{border-bottom:1px solid #e6e6e6;background:#f5f5f5;}
  .orderList .showTime p{float: left;}
  .orderList .ding{line-height:50px;margin:0 20px;}
  .orderList .ding span{color:#01b784;}
  .orderList .dan{border-left:1px solid #e6e6e6;padding-left:20px;margin-top:15px;color:#909090;}
  .orderList .clears{clear: both;}
  .orderList .listInfo li{float:left;height:130px;}
  .orderList .info1{width:162px;}
  .orderList .info1 img{width:122px;height:60px;margin:35px 20px;}
  .orderList .info2{width:230px;color:#4f4f4f;}
  .orderList .info2 h1{font-size: 18px;margin:36px 0 10px 0;}
  .orderList .info2 p span{background:url(../../assets/pcq.png)no-repeat -20px -20px;width:20px;height:26px;display: inline-block;float: left;margin-right:8px;}
  .orderList .info3{width:155px;line-height:130px;font-size: 18px;color:#4f4f4f;}
  .orderList .info4{width:108px;line-height:130px;color:#ff9900;}
  .orderList .examine{color:#909090}
  .orderList .info5{width:193px;height:100%;border-left:1px solid #b7e7d7;display:flex;justify-content: center;flex-direction: column;text-align: center;}
  .orderList .leftB{border-left:1px solid #e6e6e6;}
  .orderList .info5 p{color:#909090;cursor:pointer;}
  .orderList .immediatePay{width:90px;line-height:30px;border-radius:5px;background:#11cc99;text-align: center;margin-left:51px;color:#fff;cursor:pointer;}
  .orderList .info5 .Surplus{color:#ff9900;}
  .orderList .clear{width:0;height:0;clear:both;}
  .orderList .zhScholarship{position:relative;width:850px;height:85px;background:#e6e8f0;margin:30px 30px 0;box-sizing:border-box;display:flex;justify-content:space-between;align-items: center;}
  .orderList .zhTriangle{width: 0; height: 0; border-left: 12px solid transparent; border-right: 12px solid transparent; border-bottom: 12px solid #ffffff;position:absolute;top:-12px;right:46px;}
  .orderList .zhLeft{float:left;overflow:hidden;display:flex;justify-content:space-start;align-items:center;height:30px;}
  .orderList .zhRight{float:right;overflow:hidden;display:flex;justify-content:space-end;align-items: center;}
  .orderList .zhJiang{font-style:normal;margin:0 30px;font-size:14px;color:#4f4f4f;display:block;}
  .orderList .zhPir{color:#01b784;font-size:30px;display:block;}
  .orderList .zhJiang1{font-style:normal;margin:0 30px 0 8px;font-size:14px;color:#01b784;display:block;cursor:pointer;}
  .orderList .zhProblem{font-size:14px;color:#4f4f4f;padding-bottom:10px;padding-left:20px;position:relative;}
  .orderList .zhProblem1{font-size:12px;color:#909090;padding-bottom:16px;overflow:hidden;padding-left:20px;position:relative;}
  .orderList .zhP{font-size:16px;color:#01b784;margin-right:10px;position:absolute;display:block;top:0;left:0;}
  .orderList .zhRecord{width:850px;height:64px;background:#ffffff;margin:0 30px;box-sizing:border-box;border-bottom:2px solid #e6e8f0;position:relative;}
  .orderList .zhUnderline{width:90px;height:2px;background:#01b784;position:absolute;bottom:-2px;left:0;transition:all .5s ease;}
  .orderList .actions{color:#01b784;}
  .orderList .zhRecordList{width:850px;height:40px;margin:30px 30px 0;background:#f5f5f5;font-size:14px;color:#909090;}
  .orderList .zhWords{display:block;height:100%;display:flex;justify-content:center;align-items: center;float:left;width:208px;}
  .orderList .zhWords:nth-child(2){width:190px;}
  .orderList .zhWords:nth-child(3){padding-left:90px;width:auto;}
  .orderList .ac{display:none;}
  .orderList .zhMoney{width:850px;height:50px;box-sizing:border-box;border-bottom:1px solid #e6e6e6;margin:0 30px;}
  .orderList .zhWords1{display:block;width:208px;height:100%;display:flex;justify-content:center;align-items: center;float:left;}
  .orderList .zhWords1:nth-child(2){width:190px;}
  .orderList .zhWords1:nth-child(3){padding-left:90px;width:446px;justify-content: flex-start;overflow: hidden;}
  .orderList .zhImg{width:100%;height:100%;display:block;}
  .orderList .zhSign{font-size:20px;color:#01b784;}
  .orderList .PaymentOrder:visited{color:#fff;}
  .orderList .PaymentOrder{color:#fff;}
  .orderList .orderDetail{color:#909090;}
  .orderList .orderDetail:visited{color:#909090;}
  .orderList .zhTan{width:100%;height:100%;position: fixed;top:0;left:0;background: rgba(0,0,0,.5);display: flex;justify-content: center;align-items: center;}
  .orderList .zhBlock{width:360px;height:220px;background: #ffffff;}
  .orderList .zhBlockTop{width:100%;height:50px;border-bottom: 1px solid #e6e6e6;box-sizing: border-box;padding:0 20px;font-size: 16px;color:#4f4f4f;font-weight:600;display: flex;justify-content: space-between;align-items: center;}
  .orderList .zhIcon{font-size:20px;color:#90908f;font-weight: normal;cursor: pointer;}
  .orderList .zhTishi{width:100%;height:95px;font-size: 16px;color:#4f4f4f;display: flex;justify-content: center;align-items: center;padding:0 20px;}
  .orderList .zhQue{width:100%;box-sizing: border-box;padding:0 56px;display: flex;justify-content: space-around;}
  .orderList .zhDetermine{width:110px;height:36px;background: #00b983;border-radius: 7px;display: flex;justify-content: center;align-items: center;font-size:14px;color:#ffffff;cursor: pointer;border:0;}
  .orderList .zhDetermine1{width:110px;height:36px;background: #dddddd;border-radius: 5px;display: flex;justify-content: center;align-items: center;font-size:14px;color:#909090;cursor: pointer;}
  /*添加文字样式*/
  .orderList .zhWordAct{color:#11cc99;}
  .orderList .zhhContent{display: flex;justify-content: center;padding-top: 30px;}
  .orderList .ivu-page-total{display: none;}
  .orderList .ivu-page li{border-radius: 50%;}
  .orderList .ivu-page li:hover{border:1px solid #11cc99;}
  .orderList .ivu-page li:hover a{color:#11cc99}
  .orderList .ivu-page .ivu-page-item-active:hover a{color:#ffffff}
  .orderList .ivu-page-item-active{background-color: #11cc99;border-color: #11cc99;}
  .orderList .zhTotal{width:100%;text-align: center;line-height: 50px;}
  .display{display: none;}
  .zhCancel{border:0;}
</style>



// WEBPACK FOOTER //
// Myorder.vue?65d18984